import requestProvider from "./axiosHandler";

const getAllProductionLine = () => {

    return requestProvider
        .get('/production-line/get-all')
};

const createProductionLine = (list) => {

    return requestProvider
        .post('/production-line', {
            name: list.name,
            code: list.code
        })
};

const updateProduction = (list) => {

    return requestProvider
        .put('/production-line', {
            name: list.name,
            code: list.code,
            id: list.id
        })
};

const deleteProduction = (id) => {

    return requestProvider
        .delete(`/production-line/${id}`)
};

const getProductionLineById = (id) => {

    return requestProvider
        .get(`/production-line/${id}`)
};

const getProductionLinesWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/production-line?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
}; 

export {getAllProductionLine, createProductionLine, updateProduction, deleteProduction, getProductionLineById, getProductionLinesWithPage}